import { render, staticRenderFns } from "./SkupCreate.vue?vue&type=template&id=3dc9085f&scoped=true&"
import script from "./SkupCreate.vue?vue&type=script&lang=js&"
export * from "./SkupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc9085f",
  null
  
)

export default component.exports